import React, { useEffect, useState }from 'react'
import {LoaderSmall} from '../../components/Loader';

export default function PointsTransfer() {

    const [Loading] = useState(true);

    useEffect(() => {
        window.location.href = '/wl/passagens-aereas/programas?setLoading=false';
    }, []);

    return (
        <>{Loading && (<LoaderSmall/>)}</>
    );  
}